import PatientVehicleInsuranceItem from "./PatientVehicleInsuranceItem";

export default function PatientVehicleInsurances({classes, activeCase, isProcessed}) {
    return <>
        <PatientVehicleInsuranceItem classes={classes} activeCase={activeCase} item={activeCase.police_report?.moonbird_data?.insurances?.driver} index={0} isProcessed={isProcessed}/>
    </>
}
